// Simple markdown parser for basic formatting
import { sanitizeHtml } from './sanitizeHtml';

export function parseMarkdown(text) {
  if (!text) return '';
  
  // Check if content is already HTML (contains HTML tags)
  const isHTML = /<[a-z][\s\S]*>/i.test(text);
  
  let html = text;
  
  // If it's not HTML, we need to process markdown
  if (!isHTML) {
    // Split text into lines for line-by-line processing
    const lines = text.split('\n');
    const processedLines = [];
    
    for (let i = 0; i < lines.length; i++) {
      let line = lines[i];
      const trimmedLine = line.trim();
      
      // Check for headings (must start with # at the beginning of the line, after optional whitespace)
      if (trimmedLine.startsWith('### ')) {
        // H3 heading
        const headingText = trimmedLine.substring(4).trim();
        processedLines.push(`<h3>${headingText}</h3>`);
      } else if (trimmedLine.startsWith('## ')) {
        // H2 heading
        const headingText = trimmedLine.substring(3).trim();
        processedLines.push(`<h2>${headingText}</h2>`);
      } else if (trimmedLine.startsWith('# ')) {
        // H1 heading
        const headingText = trimmedLine.substring(2).trim();
        processedLines.push(`<h1>${headingText}</h1>`);
      } else if (trimmedLine === '') {
        // Empty line - mark as paragraph break
        processedLines.push('');
      } else {
        // Regular text line - process bold and italic, but keep as text
        let processedLine = line;
        
        // Bold: **text** (non-greedy to handle multiple bold sections)
        processedLine = processedLine.replace(/\*\*([^*]+?)\*\*/g, '<strong>$1</strong>');
        
        // Italic: *text* (but not **text** or at start of line for headings)
        processedLine = processedLine.replace(/(?<!\*)\*([^*]+?)\*(?!\*)/g, '<em>$1</em>');
        
        processedLines.push(processedLine);
      }
    }
    
    // Join lines and process paragraphs
    html = processedLines.join('\n');
    
    // Group consecutive non-empty lines into paragraphs
    // Split by double newlines (empty lines)
    const paragraphs = html.split(/\n\n+/);
    
    html = paragraphs.map(para => {
      const trimmed = para.trim();
      if (!trimmed) return '';
      
      // If it's already a heading, return as is
      if (trimmed.match(/^<[h1-6]/)) {
        return trimmed;
      }
      
      // Otherwise, wrap in paragraph and convert single line breaks to <br>
      const paraContent = trimmed.split('\n').join('<br>');
      return `<p>${paraContent}</p>`;
    }).filter(p => p !== '').join('\n');
    
  } else {
    // If it's already HTML, just process markdown patterns that might be in text nodes
    // Bold: **text**
    html = html.replace(/\*\*([^*]+?)\*\*/g, '<strong>$1</strong>');
    
    // Italic: *text*
    html = html.replace(/(?<!\*)\*([^*]+?)\*(?!\*)/g, '<em>$1</em>');
  }
  
  return sanitizeHtml(html);
}
